"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../../helpers");
var getPlacementFromAdUnitId_1 = __importDefault(require("./getPlacementFromAdUnitId"));
var getPlacementSizes_1 = require("./getPlacementSizes");
var placementUtils_1 = require("../../../helpers/placementUtils");
/**
 * generate the HTML for an adsense ad
 */
function getAdsenseAdString(adUnitId, clientId, hostAccountId) {
    // remove timestamp from placementName
    var placementName = (0, getPlacementFromAdUnitId_1.default)(adUnitId);
    var afpDetails = (0, placementUtils_1.getAfpDetails)(placementName);
    var size = getLargestSize((0, getPlacementSizes_1.getPlacementSizes)(placementName));
    if (afpDetails && size) {
        var markupFormat = afpDetails.googleMarkupFormat;
        if ((0, helpers_1.getCookie)("debug-ads")) {
            console.log("ad placement ".concat(adUnitId, " generating ").concat(markupFormat, " Adsense markup for ").concat(size[0], "x").concat(size[1]));
        }
        if (markupFormat === "variable-width") {
            return "<div style=\"width:".concat(size[0], "px;height:").concat(size[1], "px\"><ins class=\"adsbygoogle\"\n          style=\"display:block;min-width:0px;max-width:").concat(size[0], "px;width:100%;height:").concat(size[1], "px\"\n          data-ad-client=\"ca-").concat(clientId, "\"\n          data-ad-host=\"ca-host-").concat(hostAccountId, "\"\n          data-ad-host-channel=\"").concat(afpDetails.googleChannelId, "\"\n          data-ad-slot=\"").concat(afpDetails.googleAdSlot, "\">\n        </ins></div>");
        }
        else if (markupFormat === "default") {
            return "<div style=\"width:".concat(size[0], "px;height:").concat(size[1], "px\"><ins class=\"adsbygoogle\"\n          style=\"display:block;\"\n          data-ad-client=\"ca-").concat(clientId, "\"\n          data-ad-host=\"ca-host-").concat(hostAccountId, "\"\n          data-ad-host-channel=\"").concat(afpDetails.googleChannelId, "\"\n          data-ad-slot=\"").concat(afpDetails.googleAdSlot, "\"\n          data-ad-format=\"auto\"\n          data-full-width-responsive=\"true\">\n        </ins></div>");
        }
        throw new Error("ad placement ".concat(adUnitId, " failed to generate Adsense tag, invalid markupFormat: ").concat(markupFormat));
    }
    if ((0, helpers_1.getCookie)("debug-ads")) {
        console.log("ad placement ".concat(adUnitId, " failed to generate Adsense tag, no sizes found"));
    }
    throw new Error("No Size Detected For Adsense Ad");
}
exports.default = getAdsenseAdString;
function getLargestSize(sizes) {
    var largest = [0, 0];
    for (var id in sizes) {
        if (sizes[id][0] * sizes[id][1] > largest[0] * largest[1]) {
            largest = sizes[id];
        }
    }
    if (largest[0] * largest[1] == 0) {
        return undefined;
    }
    return largest;
}
